<template>
  <b-modal ref="register-modal" id="register-modal" class="registration-modal" size="sm" hide-footer no-close-on-backdrop>
    <template slot="modal-header">
      <h4 class="modal-title">Aanmelden</h4>
      <button type="button" aria-label="Close" @click="hideModal" class="close">
        <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
      </button>
    </template>
    <template slot="default">
      <keep-alive>
        <component :is="currentStep" v-bind:nextStepParent="nextStep" v-bind:previousStepParent="previousStep" v-bind:loginParent="login" v-bind:forgotPasswordParent="forgotPassword"/>
      </keep-alive>
    </template>
  </b-modal>
</template>

<script>
  import RegisterPersonalDetails from '@/components/Auth/Register/PersonalDetails.vue'
  import RegisterCompanyDetails from '@/components/Auth/Register/CompanyDetails.vue'
  import RegisterLoginDetails from '@/components/Auth/Register/LoginDetails.vue'

  export default {
    props: ['loginParent', 'forgotPasswordParent'],
    data() {
      return {
        currentStep: 'app-register-company-details'
      }
    },
    methods: {
      showModal() {
        // Reset our current step to the start
        this.currentStep = 'app-register-company-details'
        this.$refs['register-modal'].show()
      },
      hideModal() {
        this.$refs['register-modal'].hide()
      },
      login() {
        this.$refs['register-modal'].hide()
        this.loginParent()
      },
      forgotPassword() {
        this.$refs['register-modal'].hide()
        this.forgotPasswordParent()
      },
      nextStep() {
        // Niet super mooi, maar wel praktisch
        if (this.currentStep === 'app-register-company-details') {
          this.currentStep = 'app-register-personal-details'
        } else if (this.currentStep === 'app-register-personal-details') {
          this.currentStep = 'app-register-login-details'
        }
      },
      previousStep() {
        if (this.currentStep === 'app-register-personal-details') {
          this.currentStep = 'app-register-company-details'
        } else if (this.currentStep === 'app-register-login-details') {
          this.currentStep = 'app-register-personal-details'
        }
      }
    },
    components: {
      'app-register-company-details': RegisterCompanyDetails,
      'app-register-personal-details': RegisterPersonalDetails,
      'app-register-login-details': RegisterLoginDetails
    }
  }
</script>

<style lang="scss" scoped>
</style>
